import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Тексты известных кодов ID-сервиса — на языке интерфейса в момент вызова. */
export const emailErrors = (): Record<string, string> => {
  const m = messagesNow(messages)
  return {
    email_already_been_used: m.emailAlreadyUsed,
    limit_reached: m.emailLimitReached,
  }
}

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const emailDialogHint = (sent: boolean, email: string) => {
  const m = messagesNow(messages)
  return sent ? m.emailCodeSent(email.trim()) : m.emailHint
}
